<script lang="ts">
    import src from './svg/stylus_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    import IconStylus from './IconStylus.svelte';
    import WhiteColor from '../WhiteColor.svelte';

    export let scale: number = 0.6;
    export let title: string = '';
    export let backgroundColor: string = '#1c5dc7';
</script>

<div class="round-background" style="background-color: {backgroundColor}; width: {(25*scale/0.6)}px; height: {(25*scale/0.6)}px">
    <WhiteColor>
        <IconStylus {scale} on:click {title} />
    </WhiteColor>
</div>

<style>
    .round-background {
        background-color: #1c5dc7;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        /*transform: translate(-5px,-10px);*/
    }
    :global(.icon) {
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
